<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Decisión"
          directory="Comisión de acreditación"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal"
            v-if="status"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontalBlock" v-if="!status" type="horizontal" />
        <app-tab :tabs="tabsHorizontal" v-if="status" type="horizontal" />
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import * as actions from "../../../apiURL";
import { axiosPatch, axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  props: {
    evalTestId: String,
  },
  data() {
    return {
      preloader: false,
      formsTabsComplete: false,
      status:true,
      app_type: "",
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: "Miembros de la Comisión",
          component: "closure-findings-decision-commission-members",
          permission: "",
        },
        {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-index",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Plan de Mantenimiento",
          component: "closure-findings-decision-plan",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Borrador del Informe Técnico",
          component: "closure-findings-technical-reports",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Anexos",
          component: "closure-findings-decision-annexes",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Devolver proceso",
          component: "return-process-index",
          permission: "",
        },

        // {
        //   icon: "briefcase",
        //   name: "Conclusiones",
        //   component: "closure-findings-decision-conclusions",
        //   permission: "",
        // },
      ],

      tabsHorizontalBlock: [
        {
          icon: "briefcase",
          name: "Borrador del Informe Técnico",
          component: "closure-findings-technical-reports",
          permission: "",
        },
      ],
      deleteConfirmationModalActive: false,
      deleteLoader: false,
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview
        ? this.$store.state.evaluatorReview.evalTest
        : null;
    },
  },
  created() {
    this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
    this.$store.state.accreditation.currentStatus = 605;
     this.data();
    this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href = `${actions.EVALUATOR}/decision?tab=Informe%20para%20el%20cierre%20de%20hallazgos%20OEC%20y%20decisión`;
    },
    data() {
      axiosGet(
        `/technicalReport/${this.$store.state.evaluatorReview.evalTestId}`
      )
        .then((response) => {
          if (response.status == 200) {
          if (response.data.code_status == "605") {
                this.status = true; // Ocultar Procesar en otros estados posteriores.
          }else{
             this.status = false;
          }
          }
        }).catch(({ error }) => {});
     // this.$store.dispatch("getEvalTest");
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      // validar forms de tabs llenos para procesar.
      axiosGet(
        `/technicalReport/${this.$store.state.evaluatorReview.evalTestId}`
      )
        .then((response) => {
          if (response.status == 200 && response.data.memorando) {
            axiosGet(
              `${actions.DECISION_EVALUATION}/show_vigilances/${this.$store.state.evaluatorReview.evalTestId}`
            )
              .then((response) => {
                if (response.status == 200) {
                  this.formsTabsComplete = true;
                  let url = `${actions.EVALUATOR}/decision/closureFindingsDecision/process?accAppId=${this.evalTestId}`;
                  this.deleteLoader = true;
                  this.preloader = true;
                  axiosPatch(url)
                    .then(({ data: res }) => {
                      this.deleteLoader = false;
                      this.preloader = false;
                      $("#modal-confirm-id").modal("hide");
                      this.cancelled();
                      if (res.data === "OK") {
                        this.$toastr.s("Registro procesado con exito");
                        this.returnPage();
                        this.preloader = false;
                      } else {
                        this.$toastr.e(res.data);
                        this.preloader = false;
                      }
                    })
                    .catch(({ error }) => {});
                } else {
                  this.$toastr.e(
                    "Complete el formulario Plan de Mantenimiento."
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              });
            //   this.formsTabsComplete = true;
          } else {
            this.$toastr.e(
              "Complete el formulario Borrador de Informe Técnico."
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.$store.state.evaluatorReview.evalTestId}?accApp=1`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
        });
    },
  },
};
</script>
